export default "__VITE_ASSET__$T2rUrTK__"